import { Theme, useTheme } from '@mui/material/styles';

const useDynamicTheme = (): Theme => {
  const theme = useTheme();
  return theme;
};

export default useDynamicTheme;
